<template>
  <div class="sub-menu-layout">
    <div ref="tabsRef" class="tabs-container" v-if="showTabs">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane v-for="item in subMenuItems" :key="item.fullPath" :label="item.meta?.title || item.name"
          :name="item.fullPath" />
      </el-tabs>
    </div>
    <div class="content-area" :class="{ 'no-padding': $route.meta.noMainPadding }">
      <div class="scrollable-area">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubMenuLayout',
  data() {
    return {
      activeTab: '',
      tabsHeight: 0
    };
  },
  computed: {
    // 获取当前路由的子路由作为二级菜单
    subMenuItems() {
      const matched = this.$route.matched;
      if (matched.length < 2) return [];

      // 获取父路由（倒数第二个）
      const parentRoute = matched[matched.length - 2];

      // 直接从 router 配置中查找父路由的 children
      const allRoutes = this.$router.options.routes || [];

      const findRouteByPath = (routes, targetPath) => {
        for (const route of routes) {
          // 匹配路径（考虑 / 前缀）
          const routePath = route.path.startsWith('/') ? route.path : '/' + route.path;
          const targetPathNorm = targetPath.startsWith('/') ? targetPath : '/' + targetPath;

          if (routePath === targetPathNorm) {
            return route;
          }
          if (route.children) {
            const found = findRouteByPath(route.children, targetPath);
            if (found) return found;
          }
        }
        return null;
      };

      const targetRoute = findRouteByPath(allRoutes, parentRoute.path);

      if (!targetRoute || !targetRoute.children || targetRoute.children.length === 0) {
        return [];
      }

      // 过滤掉不需要显示在菜单中的子路由，并计算完整路径
      return targetRoute.children
        .filter(child => !child.meta || child.meta.hiddenInMenu !== true)
        .map(child => {
          // 计算子路由的完整路径
          const childPath = child.path.startsWith('/')
            ? child.path
            : `${parentRoute.path}/${child.path}`;

          return {
            ...child,
            fullPath: childPath
          };
        });
    },
    showTabs() {
      return this.subMenuItems.length > 0;
    }
  },
  watch: {
    '$route.path': {
      immediate: true,
      handler() {
        this.updateActiveTab();
      }
    }
  },
  mounted() {
    this.calculateTabsHeight();
  },
  methods: {
    updateActiveTab() {
      // 找到当前匹配的子路由
      const matchedChild = this.subMenuItems.find(item =>
        this.$route.path === item.fullPath || this.$route.path.startsWith(item.fullPath + '/')
      );
      this.activeTab = matchedChild ? matchedChild.fullPath : (this.subMenuItems[0]?.fullPath || '');
    },
    handleTabClick(tab) {
      const targetPath = tab.name;
      if (targetPath && this.$route.path !== targetPath) {
        this.$router.push(targetPath);
      }
    },
    calculateTabsHeight() {
      this.$nextTick(() => {
        if (this.showTabs && this.$refs.tabsRef) {
          this.tabsHeight = this.$refs.tabsRef.offsetHeight;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.sub-menu-layout {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.tabs-container {
  background-color: #fff;
  padding: 12px 24px 0 24px;
  flex-shrink: 0;
  border-bottom: 1px solid #e8e8e8;

  ::v-deep(.el-tabs__nav-wrap:after) {
    display: none;
  }

  ::v-deep(.el-tabs__item) {
    font-size: 14px;
    padding: 0 24px;
    height: 44px;
    line-height: 44px;
    color: #606266;
    transition: all 0.3s;

    &:hover {
      color: #409EFF;
    }
  }

  ::v-deep(.el-tabs__active-bar) {
    background-color: #409EFF;
    height: 3px;
    border-radius: 3px 3px 0 0;
  }

  ::v-deep(.el-tabs__item.is-active) {
    color: #409EFF;
    font-weight: 600;
  }

  ::v-deep(.el-tabs__nav-scroll) {
    display: flex;
    align-items: center;
  }
}

.content-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: calc(100vh - 60px) !important;
  overflow: hidden;

  &.no-padding {
    padding: 0 !important;
    margin: 0;
  }
}

.scrollable-area {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  height: 100%;
}

/* 滚动条美化 */
.scrollable-area::-webkit-scrollbar {
  width: 6px;
}

.scrollable-area::-webkit-scrollbar-track {
  background: rgba(240, 240, 240, 0.5);
  border-radius: 3px;
}

.scrollable-area::-webkit-scrollbar-thumb {
  background: rgba(180, 180, 180, 0.6);
  border-radius: 3px;
  transition: background 0.3s ease;

  &:hover {
    background: rgba(120, 120, 120, 0.8);
  }
}

::v-deep .el-tabs__header{
  margin-bottom: 0 !important;
}
</style>
